<template>
  <el-container>
    <el-main style="padding: 0">
      <div>
        <view-table
            ref="viewTable"
            :filter="filter"
            :limits="limits"
            :columns-property="columnsProperty"
            module="basic"
            url="productApplications"
            @addOrEdit="addEditHandle"
            @select="selectHandle"
            @delete="deleteHandle"
            @reset="resetHandle">
          <template slot="otherBtn">
            <el-button v-if="limits.delAuth && selection.length" type="danger" @click="deleteBatch">批量删除</el-button>
          </template>
          <template slot="adSearch">
            <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
              <el-form-item label="编号：">
                <el-input v-model.trim="filter.no" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="产品：">
                <el-input v-model.trim="filter.productName" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input v-model.trim="filter.note" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="制单人：">
                <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
              </el-form-item>
            </el-form>
          </template>
          <template slot="actionBtn" slot-scope="scope">
            <el-button
                v-if="limits.subAuth"
                type="primary"
                :disabled="scope.row.status !== 0"
                @click="submitHandle(scope.row)">
              提交
            </el-button>
          </template>
        </view-table>
        <!-- 编辑 -->
        <production-application-edit ref="applicationEdit" @save-success="loadData(1)"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import ProductionApplicationEdit from "@/views/fm/ProductionApplication/ProductionApplicationEdit";

  export default {
    name: "ProductApplicationList",
    components: {
      ViewTable,
      ProductionApplicationEdit,
    },
    data() {
      return {
        limits: {
          addAuth: this.$auth(238),
          editAuth: this.$auth(239),
          delAuth: this.$auth(240),
          subAuth: this.$auth(239),
        },
        importLoading: false,
        mainBoxHeight: 0,
        data: [],
        filterText: "",
        filter: {
          creatorName: "",
          no: "",
          productName: "",
          note: "",
        },
        columnsProperty: [
          {
            key: "no",
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.applicationEdit.open(params.row);
                    },
                  },
                },
                params.row.no,
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
      };
    },

    methods: {
      addEditHandle(row) {
        this.$refs.applicationEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      // 提交
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", `productApplications/submit/${row.pkId}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.loadData(1);
            }
          });
        });
      },
      // 删除(单删、多删)
      deleteHandle(row) {
        console.log(row);
        let ids = [];
        ids.push(row.pkId);
        this.$http.delete("basic", "productApplications", ids).then((res) => {
          if (res.success) {
            this.loadData(1);
            this.$message.success("删除成功");
          }
        });
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
      },


      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
<style scoped>
</style>

<style>
</style>
